module.exports = __webpack_public_path__ + "static/Fatma-056d334c3cba59d4f213ad2b062b4146.png";